import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authService from './authService';
import { toast } from 'react-toastify';

// Check if the user is authenticated

const token = localStorage.getItem('token');
let saveUser = null;
if (token) {
	const tokenParts = token.split('.');
	if (tokenParts.length < 2) {
		toast.error('Invalid token format');
	} else {
		const t = tokenParts[1];
		try {
			saveUser = t ? JSON.parse(atob(t)) : null;
		} catch (error) {
			toast.error('Error decoding token:', error);
		}
	}
}

// Slice for User Login
export const signin = createAsyncThunk('/signin', async (loginData, thunkAPI) => {
	try {
		const response = await authService.signin(loginData);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();

		return thunkAPI.rejectWithValue(message);
	}
});

export const signOut = createAsyncThunk('/signout', async () => {
	await authService.signOut();
	return;
});

const initialState = {
	auth: saveUser ? saveUser : null,
	isError: false,
	isLoading: false,
	isSuccess: false,
	message: '',
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		reset: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.isSuccess = false;
			state.message = '';
		},
		resetMessage: (state) => {
			state.message = '';
		},
	},

	extraReducers: (builder) => {
		builder.addCase(signOut.fulfilled, (state) => {
			state.user = null;
			state.auth = null;
			state.isLoading = false;
			state.isSuccess = true;
			state.isError = false;
		});
	},
});

export const { reset, resetMessage } = authSlice.actions;
export default authSlice.reducer;
